import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
// Using a simple arrow character instead of an icon
import Header from '../../components/Header/Header';
import './Home.css';

const AppCard: React.FC<{
  name: string;
  description: string;
  icon: React.ReactNode;
  path: string;
  comingSoon?: boolean;
  t: (key: string) => string;
}> = ({ name, description, icon, path, comingSoon = false, t }) => {
  const navigate = useNavigate();
  
  const handleClick = (e: React.MouseEvent) => {
    if (!comingSoon) {
      navigate(path);
    }
  };

  return (
    <div 
      className={`app-card ${comingSoon ? 'coming-soon' : ''}`} 
      onClick={handleClick}
      aria-label={comingSoon ? `${name} (Coming Soon)` : name}
    >
      <div className="app-icon">
        {icon}
      </div>
      <div className="app-content">
        <div className="app-header">
          <h3>{name}</h3>
          {comingSoon && <span className="badge">{t('comingSoon')}</span>}
        </div>
        <p>{description}</p>
        {!comingSoon && (
          <div className="app-link">
            <span>{t('openApp')}</span>
            <span className="arrow-icon">→</span>
          </div>
        )}
      </div>
    </div>
  );
};

const Home: React.FC = () => {
  const { t } = useLocale();
  const apps = [
    {
      id: 'ainstein',
      name: 'AInstein',
      description: t('ainsteinSubtitle'),
      icon: <img 
        src={require('../../apps/ainstein/assets/images/icon.png')}
        alt="AInstein"
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />,
      path: '/ainstein',
      comingSoon: false
    },

    {
      id: 'roamr',
      name: 'Roamr',
      description: t('roamrSubtitle'),
      icon: <img 
        src={require('../../apps/roamr/assets/images/icon.png')}
        alt="Roamr"
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />,
      path: '/roamr',
      comingSoon: false
    },
    {
      id: 'eunoia',
      name: 'Eunoia',
      description: t('eunoiaSubtitle'),
      icon: <img 
        src={require('../../apps/eunoia/assets/images/icon.png')}
        alt="Eunoia"
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />,
      path: '/eunoia',
      comingSoon: false
    },
  ];

  return (
    <div className="home">
      <Header />
      <div className="home-content">
        <section className="hero-section">
          <img src="/profile.png" alt="Pankaj's Profile" className="profile-image" width="80" height="80" />
          <h1>{t('developerWelcome')}</h1>
          <p className="subtitle">{t('developerSubtitle')}</p>
          <p className="description">
            {t('developerDescription')}
          </p>
        </section>

        <section className="apps-section">
          <div className="section-header">
            <h2>{t('developerApps')}</h2>
            <p className="section-description">{t('developerAppsDescription')}</p>
          </div>
          
          <div className="apps-grid">
            {apps.map((app) => (
              <AppCard key={app.id} {...app} t={t} />
            ))}
          </div>
        </section>
      </div>
    </div>
  )
};

export default Home;
